import { camelCase } from 'lodash-es'
import { useDispatch, useSelector } from 'react-redux'

import { ToastMessage } from './ToastMessage'
import { hideNotification } from '../../store/actions'
import { useTranslate } from '../../utils/translate'

export function ToastMessageOverlay() {
  const notifications = useSelector<State, ImmutableList>((state) => state.getIn(['view', 'notifications']))
  const dispatch = useDispatch<GlobalDispatch>()
  const t = useTranslate('shop')

  return (
    <div className="toast-message-overlay">
      {notifications
        .filter((n) => n?.get('level') === 'error')
        .map((err) => {
          if (!err) return null

          const errorMessage = t(`notifications.${camelCase(err.get('message'))}`)
          const needsErrorId = errorMessage.endsWith(t('notifications.idExplanation'))

          return (
            <ToastMessage
              key={err.get('id')}
              onClose={() => dispatch(hideNotification(err.get('id')))}
              closeLabel={t('notifications.dismissButton.tooltip')}
              secondaryContent={needsErrorId && <code> {err.get('serverRequestId')}</code>}
            >
              {errorMessage}
            </ToastMessage>
          )
        })
        .toArray()}
    </div>
  )
}
